module.exports = __webpack_public_path__ + "public/img/hb.75441a08.png";